import { Model } from 'modules/core/lib/mobx-rest'

import { STATUS } from 'modules/attendance/lib/enums'
import type { PolicyTarget } from 'modules/permissions/store/collections/policyAuthorizations'

export interface IOvertimeRequest {
  id?: number | string
  date?: string
  employee_id?: number | string
  approver_id?: number | string
  author_id?: number | string
  hours_amount?: number
  description?: string
  reason?: string
  status?: STATUS
  day?: number
  approver?: boolean
}

class OvertimeRequest extends Model<IOvertimeRequest> implements PolicyTarget {
  // TODO: remove this after totally transfroming graphql
  static urlRoot() {
    return '/api/rest/attendance/overtime_request'
  }

  constructor(attr: IOvertimeRequest) {
    super(attr)
  }

  get policyTargetClass(): string {
    return '::Attendance::OvertimeRequest'
  }

  get hours(): number {
    return this.attributes.hours_amount || 0
  }
}

export default OvertimeRequest
